import { createIsomorphicFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";
import { readCookieLang, type Lang } from "./i18n";

/**
 * Resolves the active language identically on the server (from the request
 * cookie) and on the client (from document.cookie), so SSR markup and the
 * first client render always agree.
 */
export const resolveLang = createIsomorphicFn()
  .server((): Lang => (getCookie("spayzo.lang") === "ar" ? "ar" : "en"))
  .client((): Lang => readCookieLang());
